"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvmWalletToJSON = exports.EvmWalletFromJSONTyped = exports.EvmWalletFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function EvmWalletFromJSON(json) {
    return EvmWalletFromJSONTyped(json, false);
}
exports.EvmWalletFromJSON = EvmWalletFromJSON;
function EvmWalletFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'type': (0, _1.WalletTypeFromJSON)(json['type']),
        'address': json['address'],
        'user': json['user'],
        'webhookIds': !(0, runtime_1.exists)(json, 'webhookIds') ? undefined : json['webhookIds'],
    };
}
exports.EvmWalletFromJSONTyped = EvmWalletFromJSONTyped;
function EvmWalletToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'type': (0, _1.WalletTypeToJSON)(value.type),
        'address': value.address,
        'user': value.user,
        'webhookIds': value.webhookIds,
    };
}
exports.EvmWalletToJSON = EvmWalletToJSON;
